export const YEAR = new Date().getFullYear();
export const MONTH = new Date().toLocaleString('default', { month: 'long' });
export const LAST_MONTH = new Date(
  new Date().setMonth(new Date().getMonth() - 1)
).toLocaleString('default', { month: 'long' });
export const PHONE_DISPLAY = '(800) 990-3725';
export const PHONE_NUMBER = '+18009903725';
